export interface ErrorState {
  name: string | undefined;
  errorMessage: string | undefined;
  stack: string | undefined;
}

export const initialState: ErrorState = {
  name: undefined,
  errorMessage: undefined,
  stack: undefined
};
